import createElement from '../logical-components/createElement';
import './scss/pagination.scss';
import renderText from "../logical-components/renderText";
var renderLoadMore = function (_a) {
    var meta = _a.meta, loadMore = _a.loadMore, loadMoreAutomatic = _a.loadMoreAutomatic, wrapper = _a.wrapper;
    var element = createElement('div');
    element.className = "_msnlq-pagination-wrapper";
    if (!(meta === null || meta === void 0 ? void 0 : meta.current_page)) {
        return element;
    }
    element.innerHTML = "<div class=\"_msnlq-pg-w\">\n        <div class=\"_msnlq-pg-loadmore _msnlq-pg-b\">\n            <span class=\"_msnlq-pg-loadmore-btn\">".concat(renderText('pagination.loadMore'), "</span>\n        </div>\n        <span class=\"_msnlq-pg-loadmore-info\">").concat(renderText('pagination.loadMoreAllLoaded'), "</span>\n    </div>");
    if (loadMoreAutomatic) {
        // Add observer to load button
        var hideWhenBoxInView = new IntersectionObserver(function (entries) {
            if (entries[0].intersectionRatio > 0) { // If in view
                var isLoading = !!wrapper.querySelector('._mnslq-loader-wrapper');
                if (!isLoading) {
                    loadMore();
                }
            }
        });
        hideWhenBoxInView.observe(element);
    }
    // Buttons
    element.querySelector('._msnlq-pg-loadmore-btn').addEventListener('click', function () {
        loadMore();
    });
    return element;
};
export default renderLoadMore;
